<template>
  <div v-if="content" class="trip-box">
    <span class="trip-label">{{ title }}</span>

    <span class="trip-value">{{ content }}</span>

    <!-- existing copy icon (unchanged) -->
    <img
        v-if="copy"
        src="@/assets/images/icons/copy.svg"
        class="copy-icon-img"
        @click="copyToClipboard(content)"
    />

    <!-- NEW optional action icons (safe) -->
    <img
        v-for="(action, i) in actions"
        :key="i"
        :src="action.icon"
        class="action-icon-img"
        :title="action.title || ''"
        :alt="action.title || ''"
        :aria-label="action.title || ''"
        @click="emitAction(action.event)"
    />
  </div>
</template>


<script>
export default {
  name: "SmallInfoBox",
  props: {
    title: { type: String, required: true },
    content: { type: String, required: true },
    copy: { type: Boolean, default: false },

    // OPTIONAL new buttons
    actions: {
      type: Array,
      default: () => []    // <= safe, does not break anything
    }
  },

  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      const icon = event.currentTarget;
      icon.classList.add("copy-animate");
      setTimeout(() => icon.classList.remove("copy-animate"), 300);
    },

    emitAction(eventName) {
      this.$emit(eventName, this.content);

      const icon = event.currentTarget;
      icon.classList.add("copy-animate");
      setTimeout(() => icon.classList.remove("copy-animate"), 250);
    }
  }
};
</script>

<style lang="scss" scoped>
.trip-box {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #F5F6FA;
  border-radius: 13px;
  padding: 10px 18px;
  height: 40px;
  white-space: nowrap;
}

.trip-label {
  font-size: 12px;
  opacity: 0.7;
}

.trip-value {
  font-size: 14px;
  font-weight: 600;
  max-width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.copy-icon-img,
.action-icon-img {
  width: 12px;
  height: 12px;
  cursor: pointer;
  opacity: 0.85;
  transition: 0.15s ease;
}

.copy-icon-img:hover,
.action-icon-img:hover {
  opacity: 0.5;
  filter: brightness(0) saturate(100%) invert(20%);
}

.copy-animate {
  animation: pop 0.3s ease-out;
}

@keyframes pop {
  0% { transform: scale(1); }
  40% { transform: scale(1.5); }
  100% { transform: scale(1); }
}
</style>

